
class InternalApplicationException extends Error {

    constructor(err) {
        super(err.message);
        this.error = err;
    }
}

export default InternalApplicationException;